module.exports = "../../../../platform/assets/pageMainIcon/simple_yewushezhilei2.svg";